<template>
    <div>
        <div class="toolbar">
            <el-button type="primary" :disabled="loading" @click="openDialog()">新增应用</el-button>
        </div>
        <el-table style="margin-top: 12px" v-loading="loading" :data="data">
            <el-table-column label="排序" prop="sort" width="70"></el-table-column>
            <el-table-column label="Icon" width="90">
                <template #default="scope">
                    <el-image :src="scope.row.icon" style="width: 40px; height: 40px; border-radius: 6px"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="应用名" prop="name" width="180"></el-table-column>
            <el-table-column label="Key" prop="key" width="120"></el-table-column>
            <el-table-column label="平台包名" width="360">
                <template #default="scope">
                    <div v-for="p in scope.row.packages" :key="p.platform + ':' + p.package_name" class="package-line">
                        <el-tag>{{ p.platform }}</el-tag>
                        <span>{{ p.package_name }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="启用" width="90">
                <template #default="scope">
                    <el-switch v-model="scope.row.enabled" @change="quickUpdate(scope.row)" :disabled="loading"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="内置" width="80">
                <template #default="scope">
                    <el-tag v-if="scope.row.builtin" type="info">是</el-tag>
                    <span v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="160">
                <template #default="scope">
                    <el-button size="small" :disabled="loading" @click="openDialog(scope.row)">编辑</el-button>
                    <el-button size="small" type="danger" :disabled="loading || scope.row.builtin"
                               @click="remove(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog v-model="dialog_opened" :before-close="reset" width="760px">
            <el-form ref="formRef" :model="form" label-width="120px">
                <el-form-item label="应用 Key" prop="key" :rules="[{required: true, message: '请输入应用 Key'}]">
                    <el-input v-model="form.key" :disabled="loading || !!editing" placeholder="如 new_app"></el-input>
                </el-form-item>
                <el-form-item label="应用名" prop="name" :rules="[{required: true, message: '请输入应用名'}]">
                    <el-input v-model="form.name" :disabled="loading"></el-input>
                </el-form-item>
                <el-form-item label="Icon" prop="icon" :rules="[{required: true, message: '请上传或输入 icon'}]">
                    <div class="icon-row">
                        <el-upload action="/cms/v1/resource" :show-file-list="false" :onSuccess="handleSuccess"
                                   accept="image/*" :data="{prefix: 'app'}">
                            <img v-if="form.icon" :src="form.icon" class="icon-preview">
                            <el-button v-else size="small" :loading="loading">上传</el-button>
                        </el-upload>
                        <el-input v-model="form.icon" :disabled="loading" placeholder="或直接输入图片 URL"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="平台包名" prop="packages" :rules="[{validator: validatePackages, trigger: 'blur'}]">
                    <div class="packages">
                        <div v-for="(p, index) in form.packages" :key="index" class="package-editor">
                            <el-select v-model="p.platform" :disabled="loading || isPackageLocked()" style="width: 120px">
                                <el-option label="Android" value="android"></el-option>
                                <el-option label="iOS" value="ios"></el-option>
                            </el-select>
                            <el-input v-model="p.package_name" :disabled="loading || isPackageLocked()" placeholder="包名"></el-input>
                            <el-button icon="Delete" :disabled="loading || isPackageLocked() || form.packages.length === 1"
                                       @click="removePackage(index)"></el-button>
                        </div>
                        <el-button size="small" icon="Plus" :disabled="loading || isPackageLocked()"
                                   @click="addPackage">添加平台包名</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number v-model="form.sort" :disabled="loading" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="启用">
                    <el-switch v-model="form.enabled" :disabled="loading"></el-switch>
                </el-form-item>
                <el-form-item label="BigQuery 项目">
                    <el-input v-model="form.analytics.bigquery_project" :disabled="loading"
                              placeholder="没有指标能力可留空"></el-input>
                </el-form-item>
                <el-form-item label="功能入口">
                    <el-checkbox-group v-model="selectedFeatures" class="feature-grid">
                        <el-checkbox v-for="feature in featureOptions" :key="feature.key" :label="feature.key">
                            {{ feature.label }}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button :loading="loading" @click="reset" text>取消</el-button>
                <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import axios from "ts-axios-new";
import {ElMessage, ElMessageBox} from 'element-plus'
import {loadProductList} from "../libs/app";

const DEFAULT_ENABLED_FEATURES = [
    'material',
    'tag',
    'category',
    'update',
    'carousel',
    'suspend',
    'popup',
    'daily',
    'collection',
    'collection_sort',
];

function defaultForm() {
    return {
        key: '',
        name: '',
        icon: '',
        package_name: '',
        platform: 'android',
        packages: [{platform: 'android', package_name: ''}],
        enabled: true,
        sort: 0,
        features: {},
        analytics: {
            bigquery_project: '',
        },
    }
}

export default {
    name: "AppManagement",
    data() {
        return {
            loading: false,
            data: [],
            dialog_opened: false,
            editing: null,
            selectedFeatures: [...DEFAULT_ENABLED_FEATURES],
            featureOptions: [
                {key: 'material', label: '全局图库'},
                {key: 'tag', label: '标签管理'},
                {key: 'score', label: '素材评分'},
                {key: 'metric', label: '每日表现'},
                {key: 'category', label: '分类管理'},
                {key: 'update', label: '每日更新'},
                {key: 'carousel', label: '轮播图'},
                {key: 'suspend', label: '悬浮按钮'},
                {key: 'popup', label: '弹窗'},
                {key: 'daily', label: '盲盒'},
                {key: 'collection', label: '集合'},
                {key: 'magic_collection', label: '抽卡集合'},
                {key: 'story_collection', label: '故事集合'},
                {key: 'collection_sort', label: '集合排序'},
                {key: 'country_manual', label: '手动新手图'},
                {key: 'library_recommend', label: '首页推荐'},
                {key: 'country_hot', label: '国家热图'},
                {key: 'country_rookie', label: '国家新手图'},
                {key: 'iap', label: '内购页布局'},
                {key: 'subscription', label: '订阅活动'},
                {key: 'newbie_sales', label: '新用户活动'},
                {key: 'transsion', label: '传音'},
                {key: 'classic_import', label: 'Classic导入'},
                {key: 'find_difference', label: '找不同'},
                {key: 'match', label: 'Match'},
                {key: 'avatar', label: 'Match头像'},
            ],
            form: defaultForm(),
        }
    },
    methods: {
        defaultForm() {
            return defaultForm();
        },
        init() {
            this.loading = true;
            axios.get('/cms/v1/app').then(res => {
                this.data = res.data.data.appList;
            }).finally(_ => {
                this.loading = false;
            })
        },
        openDialog(item) {
            this.editing = item || null;
            this.form = item ? {
                key: item.key,
                name: item.name,
                icon: item.icon,
                package_name: item.package_name,
                platform: item.platform || 'android',
                packages: item.packages && item.packages.length ? item.packages.map(p => ({...p})) : [{
                    platform: item.platform || 'android',
                    package_name: item.package_name || '',
                }],
                enabled: item.enabled !== false,
                sort: item.sort || 0,
                features: item.features || {},
                analytics: item.analytics || {bigquery_project: ''},
            } : this.defaultForm();
            const features = this.form.features || {};
            this.selectedFeatures = this.featureOptions
                .filter(option => item ? features[option.key] !== false : DEFAULT_ENABLED_FEATURES.includes(option.key))
                .map(option => option.key);
            this.dialog_opened = true;
        },
        reset() {
            this.dialog_opened = false;
            this.editing = null;
            this.form = this.defaultForm();
            this.selectedFeatures = [...DEFAULT_ENABLED_FEATURES];
        },
        handleSuccess(res) {
            const name = res.data.name;
            const cdn = import.meta.env.VITE_CDN_URL || 'https://jigsaw-cdn.plutodesk.com';
            this.form.icon = `${cdn}/${name}`;
        },
        validatePackages(rule, value, callback) {
            const packages = this.form.packages || [];
            if (!packages.length || packages.some(p => !p.package_name || !p.package_name.trim())) {
                callback(new Error('请至少填写一个平台包名'));
                return;
            }
            callback();
        },
        addPackage() {
            this.form.packages.push({platform: 'android', package_name: ''});
        },
        removePackage(index) {
            this.form.packages.splice(index, 1);
        },
        isPackageLocked() {
            if (!this.editing) {
                return false;
            }
            return this.editing.builtin || this.editing.enabled !== false;
        },
        buildPayload() {
            const enabledSet = new Set(this.selectedFeatures);
            const features = {};
            this.featureOptions.forEach(option => {
                features[option.key] = enabledSet.has(option.key);
            });
            const sourcePackages = this.isPackageLocked() && this.editing
                ? this.editing.packages || [{platform: this.editing.platform, package_name: this.editing.package_name}]
                : this.form.packages || [];
            const packages = sourcePackages.map(p => ({
                platform: (p.platform || 'android').toLowerCase(),
                package_name: (p.package_name || '').trim(),
            })).filter(p => p.package_name);
            return {
                ...this.form,
                packages,
                platform: (packages[0]?.platform || 'android').toLowerCase(),
                package_name: (packages[0]?.package_name || '').trim(),
                features,
                analytics: this.form.analytics || {},
            };
        },
        submit() {
            this.$refs.formRef.validate(valid => {
                if (!valid) {
                    return;
                }
                this.loading = true;
                const payload = this.buildPayload();
                const req = this.editing
                    ? axios.put(`/cms/v1/app/${this.editing.id}`, payload)
                    : axios.post('/cms/v1/app', payload);
                req.then(_ => {
                    ElMessage.success('保存成功');
                    this.reset();
                    this.init();
                    loadProductList();
                }).finally(_ => {
                    this.loading = false;
                });
            });
        },
        quickUpdate(item) {
            this.loading = true;
            axios.put(`/cms/v1/app/${item.id}`, {
                ...item,
                analytics: item.analytics || {},
                features: item.features || {},
            }).then(_ => {
                ElMessage.success('保存成功');
                loadProductList();
            }).finally(_ => {
                this.loading = false;
            });
        },
        remove(item) {
            ElMessageBox.confirm(`确定删除 ${item.name} 吗？`, '删除应用', {
                type: 'warning',
            }).then(_ => {
                this.loading = true;
                axios.delete(`/cms/v1/app/${item.id}`).then(_ => {
                    ElMessage.success('删除成功');
                    this.init();
                    loadProductList();
                }).finally(_ => {
                    this.loading = false;
                });
            });
        },
    },
    mounted() {
        this.init();
    }
}
</script>

<style scoped>
.toolbar {
    display: flex;
    justify-content: flex-start;
}

.icon-row {
    display: grid;
    grid-template-columns: 72px 1fr;
    gap: 12px;
    width: 100%;
    align-items: center;
}

.icon-preview {
    width: 48px;
    height: 48px;
    border-radius: 6px;
    object-fit: cover;
    cursor: pointer;
}

.feature-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(120px, 1fr));
    gap: 4px 12px;
    width: 100%;
}

.package-line {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 2px 0;
}

.packages {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

.package-editor {
    display: grid;
    grid-template-columns: 120px 1fr 40px;
    gap: 8px;
}
</style>
